/**
 * App-wide remote logging (app_logs, migration 135) - the whole app's counterpart to FIND_REMOTE_LOGGING.
 *
 * Size: the database is on the 500 MB free tier; app_logs keeps 7 days. At 'info' a handful of testers costs
 * single-digit MB a week. Before bulk use (Coachella) set minLevel to 'warn': errors, stalls and missed taps still
 * land, the routine lifecycle and navigation rows stop.
 */
export const APP_REMOTE_LOGGING = {
  /** Master kill switch. */
  enabled: true,
  /** 'debug' | 'info' | 'warn' | 'error' */
  minLevel: 'info',
  /** Upload only from the native app (a dev browser would mint a session per reload - see findRemoteLogging). */
  nativeOnly: true,
};

/** Per-event minimum spacing (ms); the same event inside the window is dropped (errors are collapsed, not lost). */
export const APP_LOG_THROTTLE_MS = {
  'perf.main_thread_stall': 5_000,
  'perf.frames': 25_000,
  'console.error': 5_000,
  'ui.dock.missed_tap': 1_000,
  // One row per map per phase: two maps loading in the same second are two rows, not a repeat count.
  'map.load': 0,
  'map.download': 0,
  'map.scene_build': 0,
  default: 1_000,
};

export const APP_LOG_RING_CAPACITY = 500;
export const APP_LOG_FLUSH_SIZE_THRESHOLD = 30;
export const APP_LOG_FLUSH_INTERVAL_MS = 30_000;
export const APP_LOG_PREFERENCES_KEY = 'prii.appLog.pending';
export const APP_LOG_DISK_DEBOUNCE_MS = 2_000;
